import rules from '../shared/game-rules.json';

export interface VoteOutcome {
  caught: boolean;
  voteCounts: Record<string, number>;
  scoreDelta: Record<string, number>;
}

export const GAME_RULES = rules;

export function evaluateVotes(
  playerIds: string[],
  imposterId: string,
  votes: Record<string, string>,
): VoteOutcome {
  const activeIds = new Set(playerIds);
  const validVotes = Object.entries(votes).filter(
    ([voterId, targetId]) => activeIds.has(voterId) && activeIds.has(targetId),
  );
  const voteCounts: Record<string, number> = {};
  for (const [, targetId] of validVotes) {
    voteCounts[targetId] = (voteCounts[targetId] ?? 0) + 1;
  }
  const highest = Math.max(0, ...Object.values(voteCounts));
  const caught = highest > 0 && (voteCounts[imposterId] ?? 0) === highest;
  const scoreDelta = Object.fromEntries(playerIds.map((playerId) => [playerId, 0]));
  const teammates = playerIds.filter((playerId) => playerId !== imposterId);
  if (caught) {
    for (const playerId of teammates) {
      scoreDelta[playerId] = votes[playerId] === imposterId
        ? rules.scoring.correct_vote
        : rules.scoring.wrong_vote;
    }
  } else {
    for (const playerId of teammates) {
      scoreDelta[playerId] = rules.scoring.escaped_teammate;
    }
    scoreDelta[imposterId] = (voteCounts[imposterId] ?? 0) === 0
      ? rules.scoring.imposter_perfect_escape
      : rules.scoring.imposter_escape;
  }
  return { caught, voteCounts, scoreDelta };
}

export function applyGuessBonus(
  scoreDelta: Record<string, number>,
  imposterId: string,
  correct: boolean,
): Record<string, number> {
  if (!correct) return { ...scoreDelta };
  return {
    ...scoreDelta,
    [imposterId]: (scoreDelta[imposterId] ?? 0) + rules.scoring.imposter_correct_guess,
  };
}
